// todo: consolidate this form and the one in react-sso-landing



import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { loginSetFlowStageWatcher, loginWatcher } from "../../redux/actions/loginactioncreators";
import { FormattedMessage } from "react-intl";
import flowStages from "../../flowStages";
import { NewFADVLoginForm } from "../login/NewFADVLoginForm";
import { emailValidator } from "../login/EmailValidator";
import { EmailEntry } from "../login/EmailEntry";
import { navigateToLogin } from "../../redux/helpers/navigators";

export function ChangeEmailAddress() {
  const dispatch = useDispatch();
  const challenge = useSelector(state => state.loginForm.challenge);
  const username = useSelector(state => state.loginForm.username);
  const oldEmail = useSelector(state => state.loginForm.userInfo?.UserAttributes?.email);
  const [hasBeenSubmitted, setHasBeenSubmitted] = React.useState(false);
  const hasNoEmail = !oldEmail || oldEmail.trim() === "";

  const handleSubmit = (formData, errors) => {
    setHasBeenSubmitted(true);
    if (errors && Object.keys(errors).length > 0) {
      // Do not dispatch if there are errors
      return;
    }
    dispatch(loginWatcher({
      flowStage: flowStages.CHANGE_EMAIL_ADDRESS,
      username: username,
      challengeResponse: {
        session: challenge.session,
        challengeName: challenge.challengeName,
        challengeParameters: {
          USERNAME: challenge.challengeParameters.USER_ID_FOR_SRP,
          NEW_EMAIL: formData.emailAddress,
        }
      }
    }));
  };

  const handleSkip = () => {
    dispatch(loginSetFlowStageWatcher({
      flowStage: flowStages.SKIP_EMAIL_NOT_VERIFIED,
    }));
  };

  const handleReturnToSignIn = () => {
    navigateToLogin();
  };

  return (
    <NewFADVLoginForm
      onSubmit={handleSubmit}
      showErrors={hasBeenSubmitted}
      requiredFields={["emailAddress"]}
      headerContent="Change email" //Todo: localize
      submitButtonText={<FormattedMessage id="login.changeEmailSubmit" defaultMessage="Submit" description="Submit button for changing email address" />}
      secondaryButtonText={<FormattedMessage id="login.skipEmailSubmit" defaultMessage="Skip This Step" description="Button to skip changing email address" />}
      secondaryButtonHandler={handleSkip}
      secondaryButtonId="skip"
      middleContent={(
        <div className="flex flex-col justify-center items-center">
          <button
            type="button"
            id="returnToSignIn"
            className="w-full bg-white hover:bg-gray-50 text-gray-700 font-medium py-2 px-4 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg transition-colors duration-200"
            onClick={handleReturnToSignIn}
          >
            <FormattedMessage id="signup.returnToSignIn" defaultMessage="Return to Sign In" description="Button text to return user from email flow to login form" />
          </button>
        </div>
      )}
    >
      <div className="text-base">
        {hasNoEmail ? (
          <FormattedMessage
            id="login.noEmailBlurb"
            defaultMessage="No email address is currently associated with your account. Please enter a valid email address to continue. We'll send a confirmation code to that email for verification."
            description="Blurb explaining user needs to provide an email address"
          />
        ) : (
          <FormattedMessage
            id="login.changeEmailBlurb"
            defaultMessage="Your email address is in use by a different login. Please change your email address. A confirmation email will be sent to the new address with a code."
            description="Blurb explaining why user must change email address"
          />
        )}
      </div>
      <EmailEntry
        id="emailAddress"
        name="emailAddress"
        autoFocus={true}
        match={oldEmail}
        validator={emailValidator}
      />
    </NewFADVLoginForm>
  );
}
